module.exports = __webpack_public_path__ + "img/2a5fda2.png";